export const SKIP_ONBOARDING_VIDEO_PRO_TYPES = ['irp', 'agency'];
